export default __webpack_public_path__ + "static/media/16.5127ce0e.jpg";